import accounting from 'accounting';

export const currencyFormatterNoDecimal = (value: string | number): string => {
	if (isNaN(value as any)) {
		console.warn('Item is not a number and cannot be formatted.', { value });
		return value.toString();
	}

	const isNegativeValue = value.toString().includes('-');
	const decimalPosition = value.toString().indexOf('.');
	const nonDecimalValue =
		decimalPosition > 0
			? value.toString().substring(0, decimalPosition).replace('-', '')
			: value.toString().replace('-', '');
	const onlyDecimalValue =
		decimalPosition > 0
			? value.toString().substring(decimalPosition, value.toString().length)
			: '';

	const temp = reverseString(nonDecimalValue);

	var tempCurrencyString = '';
	for (let currencyIndex = 0; currencyIndex < temp.length; currencyIndex++) {
		const char = temp[currencyIndex];
		tempCurrencyString += char;
		if (currencyIndex != temp.length - 1 && (currencyIndex + 1) % 3 == 0)
			tempCurrencyString += ',';
	}

	var currencyString = '';
	currencyString += reverseString(tempCurrencyString);
	currencyString += onlyDecimalValue;
	const symbol = isNegativeValue ? '-R' : 'R';
	let currencyStringformat = accounting.formatMoney(currencyString, symbol, 0); //signifies no decimal
	return currencyStringformat;
};

const reverseString = (str: string) => {
	var splitString = str.split('');
	var reverseArray = splitString.reverse();
	var joinArray = reverseArray.join('');
	return joinArray;
};
export const name: string = '';

export const formatCurrencyInputValue = (
	value: string | number | null,
	digits: number = 2
) => {
	const numberFormatter = new Intl.NumberFormat('fr-FR', {
		maximumFractionDigits: digits,
		useGrouping: true
	});

	if (value !== null) {
		if (typeof value === 'number') {
			value = value.toString();
		}
		value = value.replace(/\s+/g, '');
		if (/^\d+(\.\d+)?$/.test(value)) {
			value = parseFloat(value);
			value = numberFormatter.format(value);
			value = value.replace(/,/g, '.');
		}
	}
	return value;
};

export const CurrencyFormatter = (value: number | string) => {
	return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: 'ZAR' }).format(Number(value));
}
